// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const nematvColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#A020EF',
  secondary: '#A020EF',
}

export const darkTheme = {
  colors: nematvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: nematvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: nematvColors.primaryGray,
    secondary: nematvColors.secondaryGray,
    disabled: nematvColors.grayText,
    link: nematvColors.secondaryGray,
    hint: nematvColors.white,
    highlight: nematvColors.secondary,
    gray: nematvColors.primaryGray,
    seeAll: nematvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: nematvColors.primaryGray,
    gray: nematvColors.secondaryGray,
  },
  filter: {
    primary: nematvColors.primaryGray,
    secondary: nematvColors.secondaryGray,
    disabled: nematvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: nematvColors.dark,
    color: nematvColors.white,
    border: nematvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: nematvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: nematvColors.dark,
        selected: nematvColors.dark,
        progress: rgba(nematvColors.primary, 0.3),
        past: rgba(nematvColors.primary, 0.3),
        pastSelected: nematvColors.dark,
        pastHover: nematvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(nematvColors.primary, 0.2),
      },
      text: {
        empty: nematvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: nematvColors.white,
    subTitle: nematvColors.secondaryGray,
    bg: nematvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
